import { FacebookCardPreviewRender } from "./facebook-card-preview-render";
import { InstagramCardPreviewRender } from "./instagram-card-preview-render";
import { TikTokCardPreviewRender } from "./tiktok-card-preview-render";
import { YouTubeCardPreviewRender } from "./youtube-card-preview-render";
import type { DetectedLinksMap } from "../../../core/sns-detector";

type CardPreviewArgs = {
    cardElement: Element;
    detectedLinks: DetectedLinksMap;
    ogpRenderer?: { processCard?: (cardElement: HTMLElement) => void | Promise<void> } | null;
};

export class SnsCardPreviewPreviewsRender {
    public static addPreviewsToCard(args: CardPreviewArgs): void {
        const { cardElement, detectedLinks, ogpRenderer } = args;

        if (detectedLinks.youtube?.length) {
            YouTubeCardPreviewRender.addYouTubePreviewToCard(cardElement, detectedLinks);
        }
        if (detectedLinks.facebook?.length) {
            FacebookCardPreviewRender.addFacebookPreviewToCard(cardElement, detectedLinks);
        }
        if (detectedLinks.instagram?.length) {
            InstagramCardPreviewRender.addInstagramPreviewToCard(cardElement, detectedLinks);
        }
        if (detectedLinks.tiktok?.length) {
            TikTokCardPreviewRender.addTikTokPreviewToCard(cardElement, detectedLinks);
        }

        if (cardElement instanceof HTMLElement && ogpRenderer && typeof ogpRenderer.processCard === "function") {
            ogpRenderer.processCard(cardElement);
        }
    }
}
